module.exports = require('./helpers/bundle-url').getBundleURL('1xtho') + "logo-dark.ba5147f0.svg";